"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import Link from "next/link";
import { MoveRight } from "lucide-react";
const CTA_STYLE = `
    .cta-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 2;
    }
`;
const ResearchCTA = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{CTA_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 30
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 1,
      ease: [0.16, 1, 0.3, 1]
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 opacity-[0.08] bg-[radial-gradient(circle_at_30%_50%,#C9A84C_0%,transparent_55%)] pointer-events-none" aria-hidden={true} />;
    t6 = <div className="absolute inset-4 sm:inset-6 md:inset-8 border border-white/40 pointer-events-none z-10 hidden sm:block" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-2 sm:gap-3 mb-5 sm:mb-8"><div className="w-8 h-px bg-[#C9A84C]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#C9A84C] font-light">Start Your Journey</span><div className="w-8 h-px bg-[#C9A84C]" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h2 className="font-display text-[32px] sm:text-[44px] md:text-[56px] lg:text-[64px] font-light leading-[1.05] tracking-[-0.02em] text-[#F4EFE6] mb-4 sm:mb-6">Begin Your Research <br className="hidden sm:block" /><em className="text-[#C9A84C] italic">Journey</em></h2>;
    t9 = <p className="font-body text-[14px] sm:text-[15px] md:text-[16px] font-light leading-[1.7] sm:leading-[1.85] text-white/70 max-w-[600px] mb-8 sm:mb-12">Explore reports, archives, migration records, and stories from Girmitiya communities around the world, all in one comprehensive digital platform.</p>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <>{t0}<section className="font-body bg-[#F4EFE6] py-16 sm:py-24 md:py-32"><div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8"><motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="relative cta-grain bg-[#0F1C2E] overflow-hidden">{t5}{t6}<div className="relative z-20 py-14 sm:py-20 md:py-24 px-5 sm:px-8 md:px-16 text-center flex flex-col items-center">{t7}{t8}{t9}<div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 w-full"><Link href="/archives" className="font-body inline-flex items-center justify-center gap-2.5 px-8 py-3.5 sm:py-4 bg-[#C9A84C] text-[#0F1C2E] text-[11.5px] sm:text-[12.5px] font-medium tracking-[0.08em] uppercase hover:bg-[#F4EFE6] transition-colors duration-300 group w-full sm:w-auto">Browse Archives<MoveRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" /></Link><Link href="/reports" className="font-body inline-flex items-center justify-center gap-2.5 px-8 py-3.5 sm:py-4 border border-white/20 text-white text-[11.5px] sm:text-[12.5px] tracking-[0.08em] uppercase hover:border-white hover:bg-white/5 transition-colors duration-200 w-full sm:w-auto">Start Exploring</Link></div></div></motion.div></div></section></>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
export default ResearchCTA;